// extracted by mini-css-extract-plugin
module.exports = {"page_header":"BezOtkazaPage_page_header__GM4hX","page_header_title":"BezOtkazaPage_page_header_title__3ZTuV"};